export { default } from "./Allowlisted"
